export enum HelperFileTypesEnum {
    SENDER = "Sender",
    CONTENT = "Content",
    ATTACHMENTS = "Attachments",
    LINKS = "Links"
}
